<template>
  <div class="row-bank-rule d-flex">
    <div class="d-flex draggable-box pr-0">
      <v-icon class="draggable-icon" color="primary">mdi-drag</v-icon>
        <div class="rule-number">{{ rule.order + 1}}</div>                        
    </div>
    <div class="d-flex flex-column content-bank-rule">
      <div class="pl-4 pr-2">
        <v-select
          class="kind-rule-select"
          :items="rule_types"
          v-model="rule.kind"
          outlined
          dense
          hide-details
          @change="changeKindRule"
          append-icon="mdi-chevron-down">        
        </v-select>
      </div>

      <div class="bank-rule-intro" v-if="rule.kind && rule.kind == 'cif_account_counterpart'">
        Asignar contrapartida por el CIF del tercero encontrado en el movimiento.
      </div>
      <div class="bank-rule-intro" v-if="rule.kind && rule.kind == 'invoice_number_account_counterpart'">
        <template v-if="work_with_effects">
          Asignar el efecto cuyo numero de factura de cliente se encuentre en el movimiento y coincida el importe.        
        </template>
        <template v-else>
          Asignar la cuenta de la factura de cliente cuyo número se encuentre en el movimiento y coincida el importe.        
        </template>
      </div>
      <div class="bank-rule-intro" v-if="rule.kind && rule.kind == 'amount_account_counterpart'">
        <template v-if="work_with_effects">
          Asignar el efecto cuyo importe coincida con el importe del movimiento.
        </template>
        <template v-else>
          Asignar la cuenta de la factura cuyo importe coincida con el importe del movimiento.
        </template>
      </div>
      <div class="bank-rule-intro" v-if="rule.kind && rule.kind == 'third_party_concept_account_counterpart'">
        <template v-if="work_with_effects">
          Asignar el efecto que contenga el mismo nombre de tercero en el concepto y coincida el importe exacto.
        </template>
      </div>

      <div class="pt-1 pb-1 pl-0" v-if="!rule.kind || !(['cif_account_counterpart', 'invoice_number_account_counterpart', 'amount_account_counterpart', 'third_party_concept_account_counterpart'].includes(rule.kind))">
        <div class="d-flex pr-2">
          <v-btn
            v-if="rule.revision_needed"             
            class="ia-rule-revision-btn"            
            width="10"
            height="10"
            icon
            @click="dialog_ia_condition = true"
            >                    
            <v-icon class="ia-rule-icon">mdi-star-four-points-small</v-icon>
          </v-btn>
          <v-textarea 
            no-resize 
            outlined
            :label="rule.revision_needed ? 'Condición generada por IA' : 'Condición'"
            rows="1" 
            class="py-0"
            :class="!rule.revision_needed ? 'ml-1_5' : ''" 
            :name="tab.code == 'debit' ? 'debit_rule_' + index : 'debit_rule_' + index" 
            v-model="rule.text"
            @input="setDirty"
            auto-grow >
          </v-textarea>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs" 
                v-on="on"
                icon
                class="btn-copy-condition align-self-end"
                @click="copyToClipboard(rule.text)"
                >
                <v-icon>mdi-content-copy</v-icon>
              </v-btn>               
            </template>
            <span>Copiar contenido</span>
          </v-tooltip>
        </div>                                                                                                                     
      </div>
     
      <v-row no-gutters class="pb-1 align-center px-1_5" v-if="!rule.kind || rule.kind == 'account_counterparts' ">
        <v-col cols="6">
          <div class="d-flex align-center">
            <div class="bank-rules-counterpart-container d-flex justify-space-between" style="width: 100%;">
              <div class="counterpart-label">Contrapartida</div>
              <ContrapartidaField
                v-if="!rule.counterpart || rule.counterpart.length <= 1"
                v-model="rule.counterpart[0].account"
                :items="accounts"
                @input="setDirty"
                @change="setDirty"
                @get-values="getValues"
                @reset-items="resetItems"
                class="bank-rules-counterpart"  
                :num_digits="num_digits"
                >
              </ContrapartidaField>
              <div v-else-if="rule.counterpart" class="counterpart-text">{{ rule.counterpart.length }} contrapartidas</div>                          
            </div>
            <v-btn class="btn-add-counterpart ml-1" icon outlined @click="openCounterpartsRulesDialog(rule)" >
              <v-icon v-if="!rule.counterpart || rule.counterpart.length <= 1" color="primary">mdi-plus</v-icon>
              <v-icon v-else color="primary">mdi-pencil</v-icon>                                      
            </v-btn>
          </div>
        </v-col>                    
        <v-col cols="6" align="right">          
          <div class="btn-add-concept d-flex align-center justify-end" v-if="!rule.show_concept">
            <v-btn
              icon                                                      
              color="primary"
              @click="openConcept()">
              <v-icon>mdi-pencil-outline</v-icon>
            </v-btn>
            <div class="btn-label"><span class="hidden-1230-960">Introduce </span><span class="font-weight-medium">Concepto</span></div>
          </div>
        </v-col>
      </v-row>                    
      <div class="bank-rules-concept-container d-flex" v-if="rule.show_concept && (!rule.kind || !(['cif_account_counterpart', 'invoice_number_account_counterpart', 'amount_account_counterpart', 'third_party_concept_account_counterpart'].includes(rule.kind)))">
        <v-textarea
          outlined
          label="Concepto"
          no-resize
          rows="1"
          v-model="rule.concept"
          :name="tab.code == 'debit' ? 'debit_rule_concept_' + rule.order : 'credit_rule_concept' + rule.order"
          @input="setDirty"
          auto-grow          
        >
        </v-textarea>
        <div class="d-flex flex-column justify-space-between">
          <v-btn
            icon
            class="btn-close-concept"
            @click="closeConcept()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs" 
                v-on="on"
                icon
                class="btn-copy-concept"
                @click="copyToClipboard(rule.concept)"
                >
                <v-icon>mdi-content-copy</v-icon>
              </v-btn>               
            </template>
            <span>Copiar contenido</span>
          </v-tooltip>

        </div>        
      </div>
    </div>                    
    
    <v-btn class="btn-remove-rule" 
      outlined
      icon 
      @click.prevent="removeBankRule()"
    >
      <v-icon>mdi-trash-can-outline</v-icon>
    </v-btn>
        
    
    
    <dialog-bank-counterpart
      v-if="rule.kind == 'account_counterparts'"       
      :show_message="showDialogCounterPart"             
      :object_id="index"
      :object_amount="100"
      dialog_type="percentage"
      :counterparts="rule.counterpart"
      :company_id="company_id"
      :num_digits="num_digits"
      @close-dialog="closeRulesCounterpartsDialog"
      @save-dialog="saveRulesCounterpartsDialog" >
    </dialog-bank-counterpart>        

    <v-dialog
        v-model="dialog_ia_condition"        
        content-class="dialog-ia-condition"
        >        
        <v-card>
          <v-btn
            icon
            class="btn-close-dialog-ia"
            @click="dialog_ia_condition = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>          
          <v-card-text>            
            <div class="label-ia-rule-condition">Condición anterior</div>

            <div class="old-rule-condition">{{ rule.old_condition }}</div>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn class="btn-aprove" small rounded color="primary" @click="aproveIACondition">Aprobar</v-btn>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs" 
                  v-on="on"
                  icon
                  class="btn-copy-old-condition"
                  @click="copyToClipboard(rule.old_condition)"
                  >
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>               
              </template>
              <span>Copiar contenido</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>

    </v-dialog>
    
  </div>  
</template>

<script>
import { mapActions } from "vuex";
import ContrapartidaField from './layout/ContrapartidaField.vue';
import DialogBankCounterpart from "./DialogBankCounterpart.vue";

export default {
  name: 'BankRule',
  components: {      
    ContrapartidaField,
    DialogBankCounterpart      
  },
  props: {
    index: {
      type: Number,
      required: true
    },
    rule: {
      type: Object,
      required: true
    },
    tab: {
      type: Object,
      required: true
    },
    company_id: {
      type: [Number, String],
      required: true
    },
    num_digits: {
      type: Number,
      required: true
    },
    work_with_effects: {
      type: Boolean,
      required: true
    }
  },
  data () {
      return {
        dialog_rule: null,
        showDialogCounterPart: false,
        dialog_ia_condition: false,
        accounts: []
      }
  },
  methods: {
    ...mapActions("cru", ['getAccounts2']),    
    async getValues(params) {
      params['companydb_id'] = this.company_id
      let items = await this.getAccounts2(params);
      this.accounts = items;
    },
    resetItems(params) {
      this.accounts = params;
    },
    openConcept() {      
      this.rule.show_concept = true;        
    },
    closeConcept() {        
      this.rule.concept = '';
      this.rule.show_concept = false;
      this.setDirty();
    },
    removeBankRule(){
      this.$emit('removeBankRule',{tab:this.tab,index:this.rule.order})
    },
    setDirty() {      
      this.$emit('setDirty');
    },
    openCounterpartsRulesDialog() {
      this.showDialogCounterPart = true;      
      this.dialog_rule = this.rule
    },
    closeRulesCounterpartsDialog() {
      this.showDialogCounterPart = false;
    },
    saveRulesCounterpartsDialog(data) {
      this.rule.counterpart = data.counterparts;
      this.setDirty();
      this.showDialogCounterPart = false;
    },
    async copyToClipboard(value) {
      try {        
        await navigator.clipboard.writeText(value);          
      } catch (error) {
        console.error(error.message);
      }
    },
    aproveIACondition() {
      this.dialog_ia_condition = false;
      this.rule.revision_needed = false;
      this.setDirty();
      this.$emit('aproveIACondition');
    },
    changeKindRule() {
      if (this.rule.kind == 'counterpart_by_vat' || this.rule.kind == 'cif_account_counterpart' || this.rule.kind == 'invoice_number_account_counterpart' || this.rule.kind == 'third_party_concept_account_counterpart'){
        this.rule.counterpart =  [{'amount': 100, 'account':""}]
        this.rule.show_concept = true;
      }
      this.setDirty();
    }
  },
  created() {
    // Migracion counterpart de string a array de string
    if (typeof this.rule.counterpart == 'string') {
      this.rule.counterpart = [{'amount': 100, 'account': this.rule.counterpart }]
    }
    if (!this.rule.kind) {
      this.rule.kind = 'account_counterparts'
    }
  },
  computed: {
    rule_types() {
      const baseTypes = [
        { value: "account_counterparts", text: "Contrapartidas cuenta" },
        { value: "cif_account_counterpart", text: "Contrapartida cuenta por CIF" },
        { value: "invoice_number_account_counterpart", text: "Contrapartida por Num. Factura"},
        { value: "amount_account_counterpart", text: "Contrapartida por Importe"}
      ];

      // Solo añadir la regla de terceros si se trabaja con efectos
      if (this.work_with_effects) {
        baseTypes.push({ value: "third_party_concept_account_counterpart", text: "Contrapartida por Nombre de Tercero" });
      }

      return baseTypes;
    }
  },
  watch: {    
    rule(newValue, oldValue) {       
      if (oldValue != null) {
        this.rule = newValue;
      }
    }
  }
}
</script>

<style scoped>

.row-bank-rule  .content-bank-rule {
  width: 100%;
  background-color: #f4f4f4;
  border-radius: 8px;
  padding: 0px 3px 8px 3px;  
  margin-top: 5px;
  margin-left: -15px;
}

.row-bank-rule .ia-rule-revision-btn {
  width: 16px;
  height: 16px;
  z-index:2;
  align-self:center;  
  margin-right:-5px;
}
.row-bank-rule .ia-rule-revision-btn:hover {
  background-color: #bebcfd;
}
.row-bank-rule .ia-rule-revision-btn .ia-rule-icon {
  width: 26px;
  height: 26px;
  font-size:26px; 
  color:var(--v-primary-base);   
}
.row-bank-rule >>> .v-textarea {
  border-radius: 8px;  
}
.row-bank-rule >>> .v-textarea .v-label {
  font-size:10px;
  font-weight: 600;
  color: var(--v-primary-base);
  top: 5px !important;
}
.row-bank-rule >>> .v-textarea .v-label--active  {
  transform: none !important;
  -webkit-transform: none !important;
}
.row-bank-rule >>> .v-textarea fieldset {
  border-color: #B2B2B24D;
  background-color: white;  
}
.row-bank-rule >>> .v-textarea fieldset legend {
  width: 0px !important;
}
.row-bank-rule >>> .v-textarea .v-text-field__details {
  margin-bottom: 0px;
}
.row-bank-rule >>> .v-textarea textarea {  
  font-size: 12px;
  font-weight: 300;
  line-height: 18px;
  padding-bottom: 8px;
  padding-top: 12px;
}
.row-bank-rule >>> .v-textarea .v-input__slot  {
  margin-bottom: 0px;
}
.row-bank-rule >>> .btn-copy-condition {
  width: 12px;
  height: 12px;
  margin-left: -16px;
  margin-top: 4px;
  margin-bottom: 4px;  
}
.row-bank-rule >>> .btn-copy-condition .v-icon {
  font-size:10px;
  height: 10px;
  width: 10px;
}
.row-bank-rule >>> .v-input .v-text-field__details, 
.row-bank-rule >>> .v-input .v-messages {
  min-height: 0px;
}
.row-bank-rule .btn-add-concept >>> .v-btn {
  width: 22px;
  height: 22px;
  background-color: color-mix(in srgb, var(--v-primaryLight-base) 20%, white);
}
.row-bank-rule .btn-add-concept >>> .v-btn .v-icon {
  font-size:13px;
  width:13px;  
  height: 13px;  
}
.row-bank-rule .btn-add-concept .btn-label {
  font-size: 10px;  
  color: var(--v-primary-base);
  margin-left:5px;
}

.row-bank-rule .draggable-box {
  cursor: move; /* fallback if grab cursor is unsupported */
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab; 
  justify-content: right;
  z-index:2;
}
/* (Optional) Apply a "closed-hand" cursor during drag operation. */
.row-bank-rule .draggable-box:active {
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
}
.row-bank-rule .draggable-box .rule-number {
  width: 30px;
  height: 30px;
  line-height: 30px;  
  text-align: center;
  border-radius: 8px;
  background-color: color-mix(in srgb, var(--v-primaryLight-base) 20%, white);
  font-size: 18px;
  font-weight: bold;
  color:var(--v-primary-base);
  margin-left: -10px;
}
.row-bank-rule .draggable-icon {      
  font-size: 12px; 
  color:white !important;
  margin-left: 0px;
  align-items: normal;
  margin-top: 9px   
  /*margin-right: -10px;*/
}
.row-bank-rule .btn-remove-rule {    
  margin-left: -12px;
  margin-top: 0px;
  color: #C7C7C8;
  background-color: white;
  width: 22px;
  height: 22px;
}
.row-bank-rule .btn-remove-rule .v-icon {
  height: 14px;
  font-size: 14px;
  color: #565656;
  width: 14px;
}
.row-bank-rule .bank-rules-counterpart-container {
  background-color: white;
  border: 1px solid #B2B2B24D;
  border-radius: 8px;  
  padding:0px 8px;
  align-items: center;
}
.row-bank-rule .bank-rules-counterpart {  
  background-color: white; 
  width: 100%;
}
.row-bank-rule .bank-rules-counterpart-container .counterpart-label {
  font-size:10px;
  font-weight: 600;
  color: var(--v-primary-base);
}
.row-bank-rule .bank-rules-counterpart-container .counterpart-text {
  font-size:12px;
  font-weight: 300;
  padding-top: 5px;
  padding-bottom: 5px;
}

.row-bank-rule .bank-rules-counterpart >>> .v-input__slot,
.row-bank-rule .bank-rules-counterpart >>> .v-input__control {
  min-height: 30px;
}
.row-bank-rule .bank-rules-counterpart >>> input,
.row-bank-rule .bank-rules-counterpart >>> label {
  font-size:10px;
  margin-right: 5px;
  text-align: right;
}
.row-bank-rule .bank-rules-counterpart >>> input {
  width: 70px;
}
.row-bank-rule .bank-rules-counterpart >>> .v-label ~ input {
  width: 115px;  
}
.row-bank-rule .bank-rules-counterpart >>> label {
  left:auto !important;
  right: 0px !important;
  color:var(--v-primary-base);
}

.row-bank-rule .bank-rules-counterpart >>> .v-input__slot {
  padding:0px !important;
  box-shadow: none !important;
}

.bank-rules-counterpart-container .v-btn {
  background-color: white;  
  width: 20px;
  height: 20px;
}
.bank-rules-counterpart-container .v-btn .v-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
}
.row-bank-rule .px-1_5 {
  padding-left:6px;
  padding-right:4px;
}
.row-bank-rule .ml-1_5 {
  margin-left:6px;
}
.bank-rules-concept-container{
  padding-left:6px;
  padding-right:4px;
}
.bank-rules-concept-container .v-btn {
  width: 12px;
  height: 12px;
  margin-left: -16px;
  margin-top: 4px;
  margin-bottom: 4px;
}
.bank-rules-concept-container .v-btn .v-icon {
  font-size: 12px;
  width: 12px;
  height: 12px;
  color: #565656;
}
.bank-rules-concept-container .v-btn.btn-copy-concept .v-icon {
  font-size: 10px;
  width: 10px;
  height: 10px;
}

.btn-add-counterpart {
  width: 16px;
  height: 16px;
  border-radius: 3px;
  background-color: color-mix(in srgb, var(--v-primaryLight-base) 20%, white);
  margin-right: -5px !important;
}
.btn-add-counterpart:hover {
  background-color: #bebcfd;
}
.btn-add-counterpart .v-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
}

.row-bank-rule .kind-rule-select {
  font-size:10px;
  font-weight: 300;
  text-transform: uppercase;
  margin-top: 5px;
  max-width: 220px;
}
.row-bank-rule .kind-rule-select >>> .v-input__slot {
  padding: 0px 0px 0px 6px !important;
  min-height: 16px !important;
}
.row-bank-rule .kind-rule-select >>> .v-select__selections, 
.row-bank-rule .kind-rule-select >>> input {
  padding: 0px !important;
  line-height: 15px;
}.row-bank-rule .kind-rule-select >>> .v-select__selection--comma {
  margin-top:0px !important;
  margin-bottom:0px !important;
}
.row-bank-rule .kind-rule-select >>> .v-input__append-inner {
  margin-top: 1px !important;
}
.row-bank-rule .kind-rule-select >>> .v-input__icon {
  height: 14px;
  width: 20px;
  min-width: 20px;
}
.row-bank-rule .kind-rule-select >>> .v-icon {
  font-size: 14px;  
  height: 14px;
}

.row-bank-rule .bank-rule-intro {
  font-size:12px;
  font-weight: 300;
  padding-left:6px;
  padding-right:4px;
  padding-bottom:4px;
  padding-top:8px;
}

@media (min-width:960px) and (max-width:1230px) {
  .row-bank-rule .hidden-1230-960 {
    display:none;  
  }
}
</style>

<style>
.dialog-ia-condition {  
  position:absolute !important;
  right:0px !important; 
  max-width: 400px;
  width: 100%;
}


.dialog-ia-condition .v-card {  
  padding-top:10px;
  border: 1px solid var(--v-primary-base);
}
.dialog-ia-condition .btn-close-dialog-ia {
  position: absolute;  
  top: 10px;
  right: 12px;  
  width: 12px;
  height: 12px;
}
.dialog-ia-condition .btn-close-dialog-ia .v-icon {
  font-size: 12px;
  width: 10px;
  height: 10px;
}
.dialog-ia-condition .v-card .label-ia-rule-condition {
  font-size: 10px;
  font-weight: 600;
  color: var(--v-primary-base);
}
.dialog-ia-condition .v-card .old-rule-condition {
  font-weight: 300;
  font-size:12px;
}
.dialog-ia-condition .btn-copy-old-condition {
  position:absolute;
  right: 10px;
  width: 16px;
  height: 16px;
}
.dialog-ia-condition .btn-copy-old-condition .v-icon {
  font-size: 12px;
}
.dialog-ia-condition .btn-aprove {
  text-transform: capitalize !important;
}
</style>